export default {
  lastCatchment: null,
  map: null,
  tileSource: undefined,
  tiles: undefined,
  view: undefined,
  img: '',
  flag: undefined,
  flagLayer: undefined,
  gps: undefined,
  name: '',
};
